import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 8a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -8","key":"svg-0"}]]

const IconCropLandscape = createReactComponent('outline', 'crop-landscape', 'CropLandscape', __iconNode);

export default IconCropLandscape;